import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const PublicInvoiceView = () => {
  const { token } = useParams();

  useEffect(() => {
    // Redirect to HTML endpoint that uses the same template as PDF
    // This ensures consistency between print view and PDF
    const sp = new URLSearchParams(window.location.search);
    const slug = sp.get('portalSlug')?.trim() || sp.get('slug')?.trim() || '';
    let htmlUrl = `/api/portal/invoice/${token}/html`;
    if (slug) {
      htmlUrl += `?portalSlug=${encodeURIComponent(slug)}`;
    }
    window.location.href = htmlUrl;
  }, [token]);

  // Show loading message while redirecting
  return (
    <div className="min-h-screen bg-[var(--ds-canvas-bg)] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[var(--ds-accent-primary)]"></div>
        <p className="mt-2 text-meta text-[var(--ds-text-muted)]">Loading invoice...</p>
      </div>
    </div>
  );
};

export default PublicInvoiceView;
